import type { Admin } from './auth.service';

/**
 * Only the `admin` role changes billing (T15): the same exact match the API
 * makes with `requireAdminRole('admin')`. Anyone signed in can read.
 */
export function hasAdminRole(admin: Pick<Admin, 'role'> | null | undefined): boolean {
    return admin?.role === 'admin';
}
